(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const rememberStyle = (frame, property, key) => {
    if (frame.dataset[key] !== undefined) return;
    frame.dataset[key] = frame.style.getPropertyValue(property);
    frame.dataset[`${key}Priority`] = frame.style.getPropertyPriority(property);
  };

  const restoreStyle = (frame, property, key) => {
    if (frame.dataset[key] === undefined) return;
    const previous = frame.dataset[key];
    const priority = frame.dataset[`${key}Priority`];

    if (previous) {
      frame.style.setProperty(property, previous, priority);
    } else {
      frame.style.removeProperty(property);
    }

    delete frame.dataset[key];
    delete frame.dataset[`${key}Priority`];
  };

  const isChatGreeting = (frame) => {
    const style = frame.getAttribute('style') || '';
    const rect = frame.getBoundingClientRect();
    const width = Number(frame.getAttribute('width')) || Math.round(rect.width);
    const height = Number(frame.getAttribute('height')) || Math.round(rect.height);

    return (
      (width === 124 && height === 95) ||
      (width >= 340 && width <= 380 && height >= 180 && height <= 230) ||
      /z-index\s*:\s*1000004/i.test(style)
    );
  };

  const isChatLauncher = (frame) => {
    const style = frame.getAttribute('style') || '';
    const rect = frame.getBoundingClientRect();
    const width = Number(frame.getAttribute('width')) || Math.round(rect.width);
    const height = Number(frame.getAttribute('height')) || Math.round(rect.height);

    return (
      (width >= 56 && width <= 72 && height >= 52 && height <= 68) ||
      /z-index\s*:\s*1000003/i.test(style)
    );
  };

  const mobileFacetsAreOpen = () =>
    [...document.querySelectorAll('.mobile-facets__inner')].some((panel) => {
      const rect = panel.getBoundingClientRect();
      const style = window.getComputedStyle(panel);
      return (
        rect.width > 0 &&
        rect.height > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0 &&
        style.visibility !== 'hidden' &&
        style.display !== 'none'
      );
    });

  const updateChatUi = () => {
    const stickyPurchaseVisible =
      document.body.classList.contains('sticky-cart-visible');
    const hideLauncher =
      mobileQuery.matches && (mobileFacetsAreOpen() || stickyPurchaseVisible);

    document.querySelectorAll('iframe').forEach((frame) => {
      if (isChatGreeting(frame)) {
        rememberStyle(frame, 'display', 'eyeurlOriginalGreetingDisplay');
        if (frame.style.getPropertyValue('display') !== 'none') {
          frame.style.setProperty('display', 'none', 'important');
        }
        return;
      }

      if (!isChatLauncher(frame)) return;

      if (hideLauncher) {
        rememberStyle(frame, 'display', 'eyeurlOriginalLauncherDisplay');
        if (frame.style.getPropertyValue('display') !== 'none') {
          frame.style.setProperty('display', 'none', 'important');
        }
      } else {
        restoreStyle(frame, 'display', 'eyeurlOriginalLauncherDisplay');
      }

      restoreStyle(frame, 'bottom', 'eyeurlOriginalLauncherBottom');
    });
  };

  let chatUpdateFrame;

  const scheduleChatUiUpdate = () => {
    window.cancelAnimationFrame(chatUpdateFrame);
    chatUpdateFrame = window.requestAnimationFrame(updateChatUi);
  };

  scheduleChatUiUpdate();

  const observer = new MutationObserver(scheduleChatUiUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'style', 'width', 'height']
  });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', scheduleChatUiUpdate);
  } else {
    mobileQuery.addListener(scheduleChatUiUpdate);
  }

  const initMobileFooterMenus = () => {
    const closeMenus = () => {
      if (!mobileQuery.matches) return;
      document.querySelectorAll('footer details.menu__details[open]').forEach((details) => {
        details.removeAttribute('open');
      });
    };

    closeMenus();

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', closeMenus);
    } else {
      mobileQuery.addListener(closeMenus);
    }
  };

  const initPurchaseConversionFixes = () => {
    if (!document.body.classList.contains('template-product')) return;

    const confidence = document.querySelector('.eyeurl-purchase-confidence');
    const contentGroup = confidence?.closest('.group-block-content');
    const confidenceBlock = contentGroup
      ? [...contentGroup.children].find((child) => child.contains(confidence))
      : null;
    const buyButtons = contentGroup?.querySelector(':scope > .buy-buttons-block');

    if (confidenceBlock && buyButtons && buyButtons.nextElementSibling !== confidenceBlock) {
      buyButtons.insertAdjacentElement('afterend', confidenceBlock);
    }

    const stickyAtc = document.querySelector('sticky-atc');
    const chooseOptions = stickyAtc?.querySelector('.button-toggle-variants');
    const mainVariantControl = [
      ...document.querySelectorAll(
        'product-info variant-selects select, product-info .variant-option__select'
      )
    ].find((control) => !control.closest('sticky-atc'));
    const stickyOverlay = stickyAtc?.querySelector('overlay-component');
    const stickyVariantPanel = stickyAtc?.querySelector('.sticky-atc__variant');

    if (stickyOverlay) stickyOverlay.setAttribute('aria-expanded', 'false');
    if (stickyVariantPanel) stickyVariantPanel.setAttribute('aria-hidden', 'true');

    if (chooseOptions && mainVariantControl) {
      chooseOptions.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (stickyOverlay) stickyOverlay.setAttribute('aria-expanded', 'false');
          if (stickyVariantPanel) stickyVariantPanel.setAttribute('aria-hidden', 'true');

          const header = document.querySelector('#header-group');
          const headerHeight = header?.getBoundingClientRect().height || 80;
          const targetTop =
            window.scrollY +
            mainVariantControl.getBoundingClientRect().top -
            headerHeight -
            16;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          window.scrollTo({
            top: Math.max(0, targetTop),
            behavior: reducedMotion ? 'auto' : 'smooth'
          });

          window.setTimeout(() => {
            mainVariantControl.focus({ preventScroll: true });
          }, reducedMotion ? 0 : 450);
        },
        true
      );
    }
  };

  const initMobileStickyAtc = () => {
    if (!document.body.classList.contains('template-product')) return;

    const stickyAtc = document.querySelector('sticky-atc');
    const mainAddButton = [...document.querySelectorAll('button[type="submit"]')]
      .find((button) => !button.closest('sticky-atc') && button.closest('product-info'));

    if (!stickyAtc || !mainAddButton) return;

    const stickyAtcAnchor = document.createComment('eyeurl-sticky-atc-anchor');
    stickyAtc.parentNode.insertBefore(stickyAtcAnchor, stickyAtc);

    const positionStickyAtc = () => {
      if (mobileQuery.matches) {
        if (stickyAtc.parentNode !== document.body) {
          document.body.appendChild(stickyAtc);
        }
        stickyAtc.style.setProperty('top', 'auto', 'important');
        stickyAtc.style.setProperty('bottom', '0px', 'important');
      } else {
        stickyAtc.style.removeProperty('top');
        stickyAtc.style.removeProperty('bottom');
        if (stickyAtcAnchor.parentNode && stickyAtc.parentNode !== stickyAtcAnchor.parentNode) {
          stickyAtcAnchor.parentNode.insertBefore(stickyAtc, stickyAtcAnchor.nextSibling);
        }
      }
    };

    const updateStickyAtc = () => {
      positionStickyAtc();

      if (!mobileQuery.matches) {
        if (stickyAtc.dataset.eyeurlMobileVisibility === 'true') {
          stickyAtc.classList.remove('is-visible');
          document.body.classList.remove('sticky-cart-visible');
          document.body.style.setProperty('--sticky-atc-height', '0px');
          delete stickyAtc.dataset.eyeurlMobileVisibility;
        }
        return;
      }

      const buttonRect = mainAddButton.getBoundingClientRect();
      const mainButtonVisible =
        buttonRect.top >= 0 && buttonRect.bottom <= window.innerHeight;
      const pageBottom = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const reachedFooter = pageBottom >= documentHeight - 50;
      const shouldShow = !mainButtonVisible && !reachedFooter;

      stickyAtc.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('sticky-cart-visible', shouldShow);
      document.body.style.setProperty(
        '--sticky-atc-height',
        shouldShow ? `${stickyAtc.offsetHeight}px` : '0px'
      );
      stickyAtc.dataset.eyeurlMobileVisibility = 'true';
      scheduleChatUiUpdate();
    };

    let stickyUpdateFrame;

    const scheduleStickyAtcUpdate = () => {
      window.cancelAnimationFrame(stickyUpdateFrame);
      stickyUpdateFrame = window.requestAnimationFrame(updateStickyAtc);
    };

    scheduleStickyAtcUpdate();
    window.setTimeout(scheduleStickyAtcUpdate, 500);
    window.addEventListener('scroll', scheduleStickyAtcUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyAtcUpdate, { passive: true });
    window.addEventListener('load', scheduleStickyAtcUpdate, { once: true });

    if ('IntersectionObserver' in window) {
      const mainButtonObserver = new IntersectionObserver(scheduleStickyAtcUpdate, {
        threshold: [0, 0.01, 1]
      });
      mainButtonObserver.observe(mainAddButton);
    }

    if ('ResizeObserver' in window) {
      const purchaseLayoutObserver = new ResizeObserver(scheduleStickyAtcUpdate);
      purchaseLayoutObserver.observe(mainAddButton);
      const productInfo = mainAddButton.closest('product-info');
      const mediaGallery = document.querySelector('media-gallery');
      if (productInfo) purchaseLayoutObserver.observe(productInfo);
      if (mediaGallery) purchaseLayoutObserver.observe(mediaGallery);
    }

    window.setTimeout(scheduleStickyAtcUpdate, 1500);
    window.setTimeout(scheduleStickyAtcUpdate, 3000);

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', scheduleStickyAtcUpdate);
    } else {
      mobileQuery.addListener(scheduleStickyAtcUpdate);
    }
  };

  const normalizeLegacyProductDescriptionImages = () => {
    if (!document.body.classList.contains('template-product')) return;

    document.querySelectorAll('#aplus img').forEach((image) => {
      const source = image.getAttribute('src') || image.dataset.src || '';

      if (/grey-pixel\.gif/i.test(source) && image.dataset.src) {
        image.setAttribute('aria-hidden', 'true');
        image.setAttribute('alt', '');
        return;
      }

      const dimensions = source.match(/__CR\d+,\d+,(\d+),(\d+)_/i);
      if (dimensions) {
        image.setAttribute('width', dimensions[1]);
        image.setAttribute('height', dimensions[2]);
      }

      image.loading = 'lazy';
      image.decoding = 'async';
    });
  };

  normalizeLegacyProductDescriptionImages();
  initMobileFooterMenus();
  initPurchaseConversionFixes();
  initMobileStickyAtc();
  scheduleChatUiUpdate();

  const storefrontTitle = document.title;
  const titleElement = document.querySelector('title');

  if (titleElement) {
    const titleObserver = new MutationObserver(() => {
      if (/^\d+\s+new messages?$/i.test(document.title.trim())) {
        document.title = storefrontTitle;
      }
    });

    titleObserver.observe(titleElement, { childList: true });
  }

  document.addEventListener(
    'click',
    (event) => {
      const chooseOptions = event.target.closest?.('sticky-atc .button-toggle-variants');
      if (!chooseOptions) return;


      const mainVariantControl = [
        ...document.querySelectorAll(
          'product-info variant-selects select, product-info .variant-option__select'
        )
      ].find((control) => !control.closest('sticky-atc'));

      if (!mainVariantControl) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const stickyAtc = chooseOptions.closest('sticky-atc');
      stickyAtc?.querySelector('overlay-component')?.setAttribute('aria-expanded', 'false');
      stickyAtc?.querySelector('.sticky-atc__variant')?.setAttribute('aria-hidden', 'true');

      const header = document.querySelector('#header-group');
      const headerHeight = header?.getBoundingClientRect().height || 80;
      const targetTop =
        window.scrollY +
        mainVariantControl.getBoundingClientRect().top -
        headerHeight -
        16;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });

      window.setTimeout(() => {
        mainVariantControl.focus({ preventScroll: true });
      }, reducedMotion ? 0 : 450);
    },
    true
  );

})();
